import { render, staticRenderFns } from "./IssueList.vue?vue&type=template&id=2034bc74&scoped=true"
import script from "./IssueList.vue?vue&type=script&lang=js"
export * from "./IssueList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2034bc74",
  null
  
)

export default component.exports